module.exports = __webpack_public_path__ + "img/active3.f00ca1a1.png";